/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/href-no-hash */
/* eslint-disable react/jsx-no-target-blank */
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'

export default function Carousel({ children, className, nav }: props) {
  return (
    <div uk-slideshow="true" className={classNames('Carousel', className)}>
      <div className="uk-position-relative">
        {children}

        {nav &&
          <div className="uk-slidenav-container uk-position-top-right uk-position-large uk-visible@s">
            <a
              href="#"
              uk-slidenav-previous="true"
              uk-slideshow-item="previous"
              className="uk-slidenav-large uk-slidenav-previous uk-slidenav uk-icon">
              <Icon name="chevron-left" />
            </a>
            <a
              href="#"
              uk-slidenav-next="true"
              uk-slideshow-item="next"
              className="uk-slidenav-large uk-slidenav-next uk-slidenav uk-icon">
              <Icon name="chevron-right" />
            </a>
          </div>
        }
      </div>
    </div>
  )
}

Carousel.propTypes = {
  children: PropTypes.any.isRequired, //
  className: PropTypes.string,
  nav: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js